import React from "react";
import MainCP  from "../../Components/CargaGraficoPagina/MainCP"

const ViewCargaPagina: React.FC = () => <MainCP/>

export default ViewCargaPagina;